export const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/swiggy/image/upload';
export const CLOUDINARY_VIDEO_BASE_URL = 'https://res.cloudinary.com/swiggy/video/upload';
export const CLOUDINARY_RAW_URL = 'https://res.cloudinary.com/swiggy/raw/upload';
export const CLOUDINARY_BASE_PARAMS = ['fl_lossy', 'f_auto', 'q_auto'];
export const CLOUDINARY_VIDEO_BASE_PARAMS = ['f_auto', 'q_auto'];
// imageKit consts
export const IMAGEKIT_BASE_URL = 'https://media-assets.swiggy.com';
